import { render, staticRenderFns } from "./AbEmptyResult.vue?vue&type=template&id=366e8946"
import script from "./AbEmptyResult.vue?vue&type=script&lang=ts"
export * from "./AbEmptyResult.vue?vue&type=script&lang=ts"
import style0 from "./AbEmptyResult.vue?vue&type=style&index=0&id=366e8946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports